import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.aufgabe-fehler-bild';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenAufgabeFehlerBildEffects {

    AufgabeFehlerBild$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_AUFGABE_FEHLER_BILD),
        mergeMap((x: ac.GetAufgabeFehlerBildAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getAufgabeFehlerBild(x.aufgabe_id, x.bild_id).pipe(
                map((result: any) => {
                    return new ac.GetAufgabeFehlerBildErfolgreichAction(result, x.aufgabe_id, x.bild_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetAufgabeFehlerBildFehlerAction(error, x.aufgabe_id, x.bild_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AufgabenQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AufgabenQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.AufgabenQueryService);
        }
        return this.service;
    }
}
